import { gql } from 'apollo-angular';

export const CreateCanvasInstanceDocument = gql`
  mutation createCanvasInstance($input: CanvasCreateInstanceInput!) {
    createCanvasInstance(input: $input) {
      id
    }
  }
`;
